import React, { Component } from 'react';
import { withRouter, Redirect, Link } from 'react-router-dom';
import {Alert, Button} from '@betareader/design-system';
import queryString from 'query-string';
import { Media } from 'src/utils/Media';

import ReactGA from 'react-ga';
// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// i18n
import { withTranslation, Trans } from 'react-i18next';
import firebase from '../../config/fire';
import { updateUser, updateUserProfile } from '../../modules/user';
import Registered from './registered';
import SalesPitch from '../../components/standard-messages/salesPitch';
import './auth.css';

export class SignUp extends Component {
  constructor(props) {
    super(props);
    this.displayNameInput = React.createRef();

    // check if the user got here by invitation
    const parsedQueryString = queryString.parse(props.location.search);
    const { target, invitationToken, lng, email } = parsedQueryString;
    if (target) {
      localStorage.setItem('br-signup-target-url', decodeURI(target));
    }
    if (lng) {
      localStorage.setItem('br-signup-lng', decodeURI(lng));
    }
    if (invitationToken) {
      localStorage.setItem(
        'br-signup-referer-token',
        decodeURI(invitationToken)
      );
    }
    if (email) {
      localStorage.setItem('br-signup-referred-email', decodeURI(email));
    }
    // const self = this;
    this.state = {
      invitationToken,
      displayName: '',
    };
  }

  componentDidMount() {
    const { location } = this.props.history;
    if (localStorage.getItem('sign-in-mode') === 'redirect') {
      localStorage.removeItem('sign-in-mode');
      this.setState({
        creatingAccount: true,
      });
    }
    ReactGA.pageview(location.pathname + location.hash + location.search);
    if (this.displayNameInput && this.displayNameInput.current) {
      this.displayNameInput.current.querySelector('input').focus();
    }
  }

  passwordChanged = (event, data) => {
    this.setState({
      password: data.value,
      passwordError:
        data.value !== undefined && data.value.length > 6
          ? false
          : 'Password needs to be at least 6 characters long',
      errorMessage: undefined,
    });
  };
  repeatPasswordChanged = (event, data) => {
    this.setState({
      repeatPassword: data.value,
      passwordsMatch: data.value === this.state.password,
      errorMessage: undefined,
    });
  };

  emailChanged = (event, data) => {
    this.setState({
      email: data.value,
      errorMessage: undefined,
    });
  };

  signIn = async type => {
    const { t } = this.props;
    if (!this.state.consent) {
      this.setState({
        error: 'consent',
        errorMessage:
          "You must agree to BetaReader's Privacy Policy & Terms of Service in order to sign up.",
      });
    } else {
      this.setState({
        creatingAccount: true,
      });
      switch (type) {
        case 'email':
          if (this.state.password && this.state.password.length >= 6) {
            try {
              const userCredential = await firebase
                .auth()
                .createUserWithEmailAndPassword(
                  this.state.email,
                  this.state.password
                );
              const idToken = await userCredential.user.getIdToken();
              this.props.updateUserProfile(idToken, {
                role: 'WRITER',
                displayName: this.state.displayName || userCredential.user.displayName,
                invitationToken: this.state.invitationToken,
              });
            } catch (e) {
              this.setState({
                errorMessage: e.message,
              });
            }
          } else {
            this.setState({
              errorMessage: t('PasswordLength'),
            });
          }
          break;
        case 'apple':
          localStorage.setItem('sign-in-mode', 'redirect');
          try {
            const appleAuthProvider = new firebase.auth.OAuthProvider(
              'apple.com'
            );
            const appleAuthResult = await firebase
              .auth()
              .signInWithRedirect(appleAuthProvider);
            const { user } = appleAuthResult;
            const idToken = await user.getIdToken();
            this.props.updateUserProfile(idToken, {
              role: 'WRITER',
              displayName: this.state.displayName || user.displayName,
              invitationToken: this.state.invitationToken,
            });
          } catch (e) {
            this.setState({
              errorMessage: e.message,
            });
          }
          break;
        case 'google':
          try {
            localStorage.setItem('sign-in-mode', 'redirect');
            const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
            const googleAuthResult = await firebase
              .auth()
              .signInWithRedirect(googleAuthProvider);
            const { user } = googleAuthResult;
            const idToken = await user.getIdToken();
            this.props.updateUserProfile(idToken, {
              role: 'WRITER',
              displayName: this.state.displayName || user.displayName,
              invitationToken: this.state.invitationToken,
            });
          } catch (e) {
            this.setState({
              errorMessage: e.message,
            });
          }
          break;
        case 'facebook':
          try {
            localStorage.setItem('sign-in-mode', 'redirect');
            const facebookAuthProvider =
              new firebase.auth.FacebookAuthProvider();
            const facebookAuthResult = await firebase
              .auth()
              .signInWithRedirect(facebookAuthProvider);
            const { user } = facebookAuthResult;
            const idToken = await user.getIdToken();
            this.props.updateUserProfile(idToken, {
              role: 'WRITER',
              displayName: this.state.displayName || user.displayName,
              invitationToken: this.state.invitationToken,
            });
          } catch (e) {
            this.setState({
              errorMessage: e.message,
            });
          }
          break;
        case 'twitter':
          localStorage.setItem('sign-in-mode', 'redirect');
          try {
            const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();
            const twitterAuthResult = await firebase
              .auth()
              .signInWithRedirect(twitterAuthProvider);
            let { user } = twitterAuthResult.user;
            let idToken = await user.getIdToken();
            this.props.updateUserProfile(idToken, {
              role: 'WRITER',
              displayName: this.state.displayName || user.displayName,
              invitationToken: this.state.invitationToken,
            });
          } catch (e) {
            this.setState({
              errorMessage: e.message,
            });
          }
          break;
        default:
      }
      this.setState({
        creatingAccount: false,
      });
    }
  };

  consentChanged = (event, data) => {
    this.setState({
      consent: data.checked,
      error: undefined,
      errorMessage: undefined,
    });
  };

  handleResendVerificationEmail = (event, data) => {
    const { user } = this.props;
    const self = this;
    event.preventDefault();
    event.stopPropagation();
    if (user !== undefined) {
      self.setState({
        verificationEmailMessage: 'Sending...',
      });
      user
        .sendEmailVerification()
        .then(function () {
          self.setState({
            verificationEmailMessage: 'Verification email sent.',
          });
        })
        .catch(function (error) {
          self.setState({
            verificationEmailMessage:
              'Failed to send verification email. ' + error,
          });
        });
    }
  };

  displayNameChanged = event => {
    const newDisplayName = event.currentTarget.value;
    this.setState({
      displayName: newDisplayName,
    });
    localStorage.setItem('br-signup-display-name', newDisplayName);
    localStorage.setItem('br-pending-display-name', newDisplayName);
  };

  render() {
    const {
      verificationEmailMessage,
      consent,
      creatingAccount,
      displayName,
      password,
      errorMessage,
    } = this.state;

    const { location, user, userProfile, t } = this.props;
    if (user !== undefined && !user.isAnonymous && !user.emailVerified) {
      return (
        <Registered
          user={user}
          verificationEmailMessage={verificationEmailMessage}
          handleResendVerificationEmail={e =>
            this.handleResendVerificationEmail(e)
          }
        />
      );
    }
    if (
      user !== undefined &&
      userProfile !== undefined &&
      !user.isAnonymous &&
      user.emailVerified
    ) {
      const parsedQS = queryString.parse(this.props.location.search);
      const redirectTo = parsedQS.redirect ||
        (['WRITER', 'BOTH'].includes(userProfile.role) ? '/mymanuscripts' : '/discover');
      return <Redirect to={redirectTo} />;
    }
    return (
      <main className="br-auth-page">
        <img className="br-auth-logo" src="/assets/images/BR-orange-horizontal.png" alt="BetaReader" />
        <div className="br-auth-columns">
          <Media greaterThan="mobile">
            {(className, renderChildren) => renderChildren && <aside className="br-auth-pitch"><SalesPitch /></aside>}
          </Media>
          <div className="br-auth-panel">
            <nav className="br-auth-tabs" aria-label={t('Account')}>
              <Link to={`/signin${location.search}`}>{t('SignIn')}</Link>
              <Link to={`/signup${location.search}`} aria-current="page">{t('CreateAccount')}</Link>
            </nav>
            {errorMessage && <Alert variant="error">{errorMessage}</Alert>}
            {user === undefined && (
              <form className="br-auth-form" aria-busy={Boolean(creatingAccount)}
                onSubmit={event => {event.preventDefault(); this.signIn('email');}}>
                <div ref={this.displayNameInput}>
                  <input className="br-field__input" type="text" autoComplete="name" maxLength={100}
                    aria-label={t('Name')} placeholder={t('Name')} value={displayName}
                    onChange={this.displayNameChanged} />
                </div>
                <input className="br-field__input" type="email" autoComplete="email"
                  aria-label={t('Email')} placeholder={t('Email')} value={this.state.email || ''}
                  onChange={event => this.emailChanged(event, {value: event.target.value})} />
                <input className="br-field__input" type="password" autoComplete="new-password"
                  aria-label={t('Password')} placeholder={t('Password')} value={password || ''}
                  aria-invalid={password !== undefined && password.length < 6}
                  onChange={event => this.passwordChanged(event, {value: event.target.value})} />
                <label className="br-auth-consent">
                  <input type="checkbox" checked={Boolean(consent)}
                    onChange={event => this.consentChanged(event, {checked: event.target.checked})} />
                  <span>
                    <Trans i18nKey="IAcceptToC" components={{
                      privacy: <a href="https://betareader.io/privacy-policy" target="_blank" rel="noopener noreferrer" />,
                      terms: <a href="https://betareader.io/terms-of-service" target="_blank" rel="noopener noreferrer" />
                    }} />
                  </span>
                </label>
                <Button type="submit" disabled={!consent || !displayName || Boolean(creatingAccount)}
                  aria-busy={Boolean(creatingAccount)}>{t('CreateAccount').toUpperCase()}</Button>
                <div className="br-auth-divider"><span>{t('OrUse')}</span></div>
                <div className="br-auth-social">
                  <Button type="button" variant="secondary" disabled={!consent || Boolean(creatingAccount)}
                    onClick={() => this.signIn('facebook')}>
                    <span className="br-auth-provider-mark br-auth-provider-mark--facebook" aria-hidden="true">f</span>{t('ContinueWithFacebook')}
                  </Button>
                  <Button type="button" variant="secondary" disabled={!consent || Boolean(creatingAccount)}
                    onClick={() => this.signIn('google')}>
                    <span className="br-auth-provider-mark br-auth-provider-mark--google" aria-hidden="true">G</span>{t('ContinueWithGoogle')}
                  </Button>
                  <Button type="button" variant="secondary" disabled={!consent || Boolean(creatingAccount)}
                    onClick={() => this.signIn('apple')}>
                    <span className="br-auth-provider-mark" aria-hidden="true">●</span>{t('ContinueWithApple')}
                  </Button>
                </div>
              </form>
            )}
          </div>
          <Media at="mobile">
            {(className, renderChildren) => renderChildren && <aside className="br-auth-pitch"><SalesPitch /></aside>}
          </Media>
        </div>
      </main>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  idToken: state.user.idToken,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateUser,
      updateUserProfile,
      changePage: newPage => push(newPage),
    },
    dispatch
  );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(SignUp))
);
